import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, switchMap } from 'rxjs/operators';
import * as ExpItemActions from './expense-item.actions';
import * as fromErrors from '../../shared';
import {
    ResponseStatus,
    IStatusMessage,
    DisplayMessageMinimum
} from '../../shared';
import * as fromShared from '../../shared';
import { ExpenseItemService } from '../expense-item.service';

@Injectable()
export class ExpenseItemEffects {
    constructor(
        private actions$: Actions,
        private service: ExpenseItemService
    ) {}

    getExpenseItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(ExpItemActions.getExpenseItems),
            switchMap(a =>
                this.service.getExpenseItems().pipe(
                    flatMap(resp => [
                        ExpItemActions.loadExpenseItems({
                            expenseItems: resp
                        }),
                        new fromShared.Errors.RemoveErrors(
                            resp
                                .filter(
                                    x =>
                                        x.Status.StatusCode ===
                                        ResponseStatus.Success
                                )
                                .map(x => x.EIListID.toString())
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        a =>
                                            a.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    // postContractCums$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(ExpItemActions.post),
    //         switchMap(a =>
    //             this.service.postContractCums(a.DirectOrIndirect, a.Todayonly, a.Asofdate, a.Tasks, a.ServiceItems, a.DirectReports, a.Txntype, a.CostCenters).pipe(
    //                 flatMap(resp => [
    //                   ExpItemActions.loadContractCumulatives({
    //                         contractCumulatives: resp
    //                     }),
    //                     new fromShared.Errors.RemoveErrors(
    //                         resp
    //                             .filter(
    //                                 x =>
    //                                     x.Status.StatusCode ===
    //                                     ResponseStatus.Success
    //                             )
    //                             .map(x => x.Txnid.toString())
    //                     ),
    //                     new fromShared.Errors.SetErrors(
    //                         [
    //                             ...resp
    //                                 .filter(
    //                                     a =>
    //                                         a.Status.StatusCode >=
    //                                         DisplayMessageMinimum
    //                                 )
    //                                 .map(a => a.Status)
    //                         ].filter(shared.Errors.filterErrors)
    //                     )
    //                 ]),
    //                 catchError(fromShared.Errors.handleServiceError)
    //             )
    //         )
    //     );
    // });

    putExpenseItems$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ExpItemActions.putExpenseItems),
            switchMap(a =>
                this.service.putExpenseItems(a.expenseItems).pipe(
                    flatMap(c => [
                        ExpItemActions.updateExpenseItems({
                            expenseItems: [
                                {
                                    id: a.expenseItems
                                        .map(x => x.EIListID)
                                        .toString(),
                                    changes: c.Items[0]
                                }
                            ]
                        }),
                        new fromShared.Errors.RemoveErrors(
                            c.Items.filter(
                                x =>
                                    x.Status.StatusCode ===
                                    ResponseStatus.Success
                            ).map(x => x.EIListID)
                        ),
                        new fromShared.Errors.SetErrors(
                            [
                                ...c.ErrorMessages.map(
                                    x =>
                                        ({
                                            StatusCode: -1,
                                            Message: x,
                                            MsgProcessID: 0,
                                            MsgEntityID: ''
                                        } as IStatusMessage)
                                ),
                                ...c.Items.filter(
                                    x =>
                                        x &&
                                        x.Status.StatusCode >=
                                            DisplayMessageMinimum
                                ).map(x => x.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        )
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
